import { Component, OnInit, Renderer2, ElementRef } from '@angular/core';

@Component({
  selector: 'ui-loader',
  template: `<div [ngClass]="type"></div>`,
  inputs: ['type', 'size', 'color']
})
export class UiLoaderComponent implements OnInit {

  public type: string = 'spinner';
  public size: string = '1x';
  public color: string = 'default';

  constructor(private renderer: Renderer2, private el: ElementRef) { }

  ngOnInit() {
    this.renderer.addClass(this.el.nativeElement, 'loader');
    this.renderer.addClass(this.el.nativeElement, this.color);
    this.renderer.addClass(this.el.nativeElement, 'size-' + this.size);
  }

}
